/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyRupee = createReactComponent("outline", "currency-rupee", "IconCurrencyRupee", [["path", { "d": "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6", "key": "svg-0" }], ["path", { "d": "M7 9l11 0", "key": "svg-1" }]]);

export { IconCurrencyRupee as default };
//# sourceMappingURL=IconCurrencyRupee.mjs.map
